import { CALL_API } from './api';
// import { getCookie } from '../lib/auth';
import { getToken } from '../lib/auth';

export default (store) => (next) => (action) => {
    const entry = action[CALL_API];

    if (typeof entry !== 'object') return next(action);

    let token = null;
    const entryType = entry.types[0];

    if (entryType.startsWith('CORE')) {
        token = getToken();
    }

    if (!token) return next(action);
    //  return false
    entry.headers = { ...entry.headers };
    if (token) {
        entry.headers.Authorization = `Bearer ${token}`;
    }
    entry.headers['Access-Control-Allow-Origin'] = '*';
    entry.headers['Access-Control-Allow-Methods'] = '*';
    entry.headers['Access-Control-Allow-Headers'] = 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With';

    next(action);
};



// WEBPACK FOOTER //
// ./src/middlewares/setToken.js